export default __webpack_public_path__ + "static/media/HIW-lol-3.fe196b0e.webp";